<template>
  <div class="container">
    <van-nav-bar title="设备详情" left-text="" left-arrow @click-left="onClickLeft">
    </van-nav-bar>
    <div class="list-box">
    <div class="list clearfix">
      <div class="flex mg10">
        <div>设备编号：{{ deviceDetail.mainNo }}</div>
        <div>
          <span :class="deviceDetail.statusDesc == '禁用' ? 'bg_c' : 'bg_b'" class="dian"></span>
          {{ deviceDetail.statusDesc }}
        </div>
      </div>
      <div class="bold mg10">{{ deviceDetail.fullCommunityName }}</div>
      <div class="flex mg10">
        <div>位置：{{ deviceDetail.location }}</div>
        <div>
          <van-switch
            :value="deviceDetail.isEnabled"
            @input="onChangeSwitch()"
            size="20px"
          />
        </div>
      </div>
      <div class="bold mg10">{{ deviceDetail.lastOnTime }}</div>
      <div v-if="!deviceDetail.isEnabled">禁用原因：{{ deviceDetail.disabledNoteDesc }}</div>
      <van-collapse v-model="activeNames" :border="false">
        <van-collapse-item :name="deviceDetail.mainNo" :border="false">
          <template #title>
            <div>
              <span class="col_b"
                >充电中({{ deviceDetail.chargingCount }})</span
              >
              <span class="fg"></span>
              <span>空闲({{ deviceDetail.freeCount }})</span>
              <span class="fg"></span>
              <span class="col_r">故障({{ deviceDetail.errorCount }})</span>
            </div>
          </template>
          <van-grid :gutter="10" :column-num="5" :border="false">
            <van-grid-item
              :class="obj.class"
              v-for="obj in deviceDetail.deviceLoopStatusList"
              :key="obj.loopNo"
            >
              {{ obj.loopNo }}
            </van-grid-item>
          </van-grid>
        </van-collapse-item>
      </van-collapse>
    </div>

    <van-popup v-model="showPopup" :close-on-click-overlay='false' round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        value-key="name"
        @cancel="onCancel"
        @confirm="onConfirm"

      />
    </van-popup>


    <div class="list">
      <div class="flex mg10">
        <div>累计充电次数</div>
        <div>{{ deviceDetail.totalChargeCount }}次</div>
      </div>
      <div class="flex mg10">
        <div>累计充电时间</div>
        <div>{{ (deviceDetail.totalChargeMinutes/60).toFixed(0) }}小时</div>
      </div>
      <div class="flex mg10">
        <div>设备累计在线运行时间</div>
        <div>{{ (deviceDetail.totalDeviceOnlineMinutes/60).toFixed(0) }}小时</div>
      </div>
      <div class="flex mg10">
        <div>设备平均使用率</div>
        <div>{{ deviceDetail.deviceAvgUsedScale }}%</div>
      </div>
    </div>

    <div class="list" v-if="deviceWarningListLength>0">
      <div class="flex mg10 blod">
        <div>告警原因</div>
        <div>告警时间</div>
      </div>
      <div class="flex mg10" v-for="(item,index) in deviceDetail.deviceWarningList" :key="index">
        <div>{{item.reasonDesc}}</div>
        <div>{{ item.createTime}}</div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios.js";
import {NavBar,Icon,Image,Toast,Loading,Picker,Field,Popup,List,search,tag,Collapse,CollapseItem,Grid,GridItem,Switch} from "vant";
export default {
  data() {
    return {
      searchType: "",
      queryType: "",
      allCount: 0,
      deviceWarningListLength:0,
      showPopup:false,
      changeItem: null,
      mainNo:'',
      columns:[],
      loading: false,
      finished: false,
      deviceDetail: {},
      activeNames: [],
      status: undefined,
      statusName: "",
      typeList: [],
      stopList: [
        { name: "设备故障", value: 1 },
        { name: "线路故障", value: 2 },
        { name: "网络欠费", value: 3 },
        { name: "电表欠费", value: 4 },
        { name: "暂停使用", value: 5 },
      ],
    };
  },
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [Toast.name]: Toast,
    [Loading.name]: Loading,
    [Field.name]: Field,
    [List.name]: List,
    [search.name]: search,
    [tag.name]: tag,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Switch.name]: Switch,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
  },
  methods: {
    
       onCancel(){
        //取消
        this.showPopup=false
      },
      onConfirm(item){
         axios.get("/device/setenabled?isEnabled=0"+"&mainNo="+this.deviceDetail.mainNo+"&disabledNote="+item.value,{}).then((res)=>{
          if(res.isSuccess){
            Toast('操作成功');
            this.getdetail()
          }
        })
        this.showPopup=false
      },
      onChangeSwitch(){
        if(this.deviceDetail.isEnabled){
          this.columns = this.stopList;
          this.showPopup = true;
        }else{
          axios.get("/device/setenabled?isEnabled=1"+"&mainNo="+this.deviceDetail.mainNo).then((res)=>{
            if(res.isSuccess){
              Toast('操作成功');
              //this.deviceDetail.isEnabled = true;
              this.getdetail()
            }
          })
        }
      },
    getdetail() {
      this.loading = true;
      axios
        .get("home/getdevicedetail?mainNo=" + this.$route.query.id)
        .then((res) => {
          // 加载状态结束
          this.loading = false;
          this.deviceDetail = res.data;
          this.deviceDetail.deviceLoopStatusList.forEach((item) => {
            //充电-2  空闲-3  故障-4
            if (item.status == 2) {
              item.class = "charging";
            } else if (item.status == 3) {
              item.class = "free";
            } else if (item.status == 4) {
              item.class = "error";
            } else {
              item.class = "";
            }
          });
          this.deviceWarningListLength=this.deviceDetail.deviceWarningList.length
        });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {},
  },
  computed: {},
  created() {
    this.getdetail()
  },
  mounted() {},
  destroyed() {},
};
</script>
<style lang="less" scoped>
body,
html {
  width: 100%;
  height: 100%;
  background: #f0f4f7;
}
.container {
  width: 100%;
  height: 100%;
  letter-spacing: 0px;
  background: #f0f4f7;
}
.list-box {
  width: 100%;
  color: #373737 !important;
  .list {
    font-size: 14px;
    width: 100%;
    background: #fff;
    margin: 12px 0;
    padding: 12px;
    .lab {
      display: inline-block;
      padding-right: 10px;
    }
    .val {
      font-size: 18px;
    }
  }
  .mg10 {
    margin-bottom: 10px;
  }
  .bold {
    font-weight: bold;
  }
}
.fg {
  width: 2px;
  height: 16px;
  display: inline-block;
  background: #7bc9ff;
  margin: 0 20px;
  vertical-align: middle;
}
.dian {
  width: 8px;
  height: 8px;
  border-radius: 8px;
  display: inline-block;
  vertical-align: middle;
}
.mg10 {
  margin-bottom: 10px;
}

.formbox {
  color: #373737 !important;
  margin: 10px 0;
}
/deep/.van-search__content {
  background-color: #fff;
}
/deep/.van-collapse-item__content {
  padding: 12px 0;
}
/deep/.van-grid-item__content {
  padding: 8px;
  color: #373737;
  border-radius: 4px;
  background: #e8fcff;
}

/deep/.charging .van-grid-item__content {
  color: #fff;
  background: #7bc9ff;
}
/deep/.error .van-grid-item__content {
  color: #fff;
  background: #ff4f45;
}
</style>
